"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelTextItem = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var odc_text_1 = __importDefault(require("@tencent/odc-text"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
exports.LabelTextItem = (0, react_1.memo)(function (props) {
  var className = props.className,
    label = props.label,
    labelMinWidth = props.labelMinWidth,
    labelMaxWidth = props.labelMaxWidth,
    text = props.text,
    _a = props.sep,
    sep = _a === void 0 ? '' : _a,
    usePopOver = props.usePopOver,
    popOverProps = props.PopOverProps,
    overlayTriggerProps = props.OverlayTriggerProps,
    itemProps = props.itemProps,
    labelProps = props.labelProps,
    textProps = props.textProps,
    size = props.size,
    title = props.title;
  var _b = __read((0, react_1.useState)(null), 2),
    trigger = _b[0],
    setTrigger = _b[1];
  var targetRef = react_1["default"].useRef(null);
  (0, react_1.useEffect)(function () {
    if (usePopOver) {
      var targetNode = targetRef.current;
      if (targetNode) {
        setTrigger(targetNode);
      }
    }
  }, [usePopOver, targetRef]);
  var nodeTitle = '';
  if (title) {
    nodeTitle = title;
  } else {
    if (typeof label === 'string') {
      nodeTitle = label;
    }
  }
  return react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: (0, classnames_1["default"])('odc-label-text-item', className)
  }, itemProps), react_1["default"].createElement(odc_text_1["default"], __assign({
    className: (0, classnames_1["default"])('odc-label-text-key', {
      ellipsis: labelMaxWidth
    }),
    title: nodeTitle,
    style: {
      minWidth: labelMinWidth,
      maxWidth: labelMaxWidth
    },
    ref: targetRef,
    size: size,
    type: "secondary"
  }, labelProps), label, sep), usePopOver && trigger && react_1["default"].createElement(spaui_1.OverlayTrigger, __assign({
    triggerTarget: trigger,
    overlay: react_1["default"].createElement(spaui_1.PopOver, __assign({}, popOverProps), label)
  }, overlayTriggerProps)), react_1["default"].createElement(odc_text_1["default"], __assign({
    className: "odc-label-text-val",
    size: size,
    label: text
  }, textProps)));
});
exports.LabelTextItem.displayName = 'LabelTextItem';
var LabelText = function LabelText(props) {
  var _a;
  var _b = props.data,
    data = _b === void 0 ? [] : _b,
    prefix = props.prefix,
    suffix = props.suffix,
    sep = props.sep,
    labelMinWidth = props.labelMinWidth,
    // 最小宽度
    labelMaxWidth = props.labelMaxWidth,
    // 最大宽度
    gap = props.gap,
    // 间隔
    rowGap = props.rowGap,
    _c = props.size,
    size = _c === void 0 ? 'normal' : _c,
    popOverProps = props.PopOverProps,
    overlayTriggerProps = props.OverlayTriggerProps,
    _d = props.usePopOver,
    usePopOver = _d === void 0 ? false : _d,
    itemProps = props.itemProps,
    labelProps = props.labelProps,
    textProps = props.textProps,
    style = props.style,
    itemClassName = props.itemClassName;
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-label-text', "odc-text-".concat(size)),
    supportAllEvents: true
  }, LabelText), {
    style: __assign((_a = {}, _a['--odc-col-gap'] = typeof gap === 'number' ? "".concat(gap, "px") : gap, _a['--odc-row-gap'] = typeof rowGap === 'number' ? "".concat(rowGap, "px") : rowGap, _a), style)
  }), prefix, data.map(function (item, index) {
    return react_1["default"].createElement(exports.LabelTextItem, __assign({
      key: index,
      className: itemClassName,
      sep: sep,
      labelMinWidth: labelMinWidth,
      labelMaxWidth: labelMaxWidth,
      usePopOver: usePopOver,
      PopOverProps: popOverProps,
      OverlayTriggerProps: overlayTriggerProps,
      itemProps: itemProps,
      labelProps: labelProps,
      textProps: textProps,
      size: size
    }, item));
  }), suffix);
};
(0, spaui_utils_1.setComponentMark)(LabelText, info_1["default"]);
exports["default"] = react_1["default"].memo(LabelText);